import React, { useCallback, useMemo, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTabFromUrl } from "../../../hooks/useTabFromUrl";
import { useMediaQuery } from "react-responsive";
import { openStatVideo } from "../../../helpers/service";
import { getUserProfile } from "../../../helpers/userProfile";

// Style
import {
  MainWrapper,
  TopWrapper,
  MainWrapperFavorite,
} from "../../../style/DasboardMain";
import "react-tabs/style/react-tabs.css";

// Components
import Navigation from "../../../components/Navigation/Navigation";
import IntroText from "../../../components/introText/index";
import Search from "../../../components/inputs/Search";
import { swapInTeamLogoPlaceholder, teamLogoPlaceholder } from "../../../helpers/teamLogo";
import {
  TabsWrapper,
  TabListWrapper,
  TabTitle,
  TabContent,
  TopList,
} from "../../../style/Favorites";

// Language
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import SmrtSearchTable from "../../../components/table/SmrtSearchTable";
import MatchTable from "../../../components/table/MatchTable";

import Overview from "../../../components/table/Overview";
import { breakpoints } from "../../../style/size";
import ButtonLink from "../../../components/link/ButtonLink";
import { LoadingWrapper } from "../../../style/Global";
import { Oval } from "react-loader-spinner";
import Breadcrumbs from "../../../components/breadcrumbs";

// Images
import arrowDown from "../../../images/down.svg";
import closeDropdown from "../../../images/up.svg";
import { Dropdown, DropdownButton, DropdownContent, DropdownItem, MatchDropdownItem, MatchCheckbox } from "../shared/ui/EventSharedStyles";
import useOutsideClick from "../../../hooks/useOutsideClick";
import EventsMatches from "./EventsMatches";
import { $apiV1, $apiV2 } from "../../../config/api";
import { useTeamLeadersData } from "./hooks/useTeamLeadersData";
import { teamEventsParams } from "../../../config/parametrs/events/teamEventsParams";
import ShotsTeam from "./ShotsTeam";
import CrossesTeam from "./CrossesTeam";
import { useNotification } from "../../../components/notification/useNotification";
import { NotificationList } from "../../../components/notification/NotificationList";
import { useLexicon } from "../../../hooks/useLexicon";
import { useParameterLexicon } from "../../../hooks/useParameterLexicon";
import { getMediaUrl, getUniqueArrayObjectsByKey } from "../../../helpers";
import { excludeAttackingTypesParameterGroups } from "../../../helpers/teamParameterGroups";
import { hasMatchStats } from "../../../helpers/matchScore";
import { getUniqueCompetitionsWithMatches } from "./helpers/competitions";
import useTeamPageFilterController from "./hooks/useTeamPageFilterController";
import {
  aggregateStatsResponse,
  buildMatchBackedOverview,
  collectOverviewStatParameterIds,
  getCompetitionSummaryLabel,
  getSeasonSummaryLabel,
  normalizeMarkerCollection,
} from "./helpers/pageFilters";
import { trackEntityView } from "../../../tracking";
import {
  buildSeasonSelectionQueryValue,
  normalizeSeasonSelectionIds,
  persistSeasonSelection,
  readStoredSeasonSelection,
} from "../shared/utils/seasonSelection";

export const TeamCardWrap = styled.div`
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  opacity: 1;
  background-color: ${(props) => props.theme.linesOpacity};
  margin-bottom: 60px;
`;

export const TeamContent = styled.div`
  padding: 20px;
  position: relative;
`;

export const TopContent = styled.div`
  display: grid;
  grid-template-columns: minmax(300px, 1.1fr) minmax(420px, 1.5fr) minmax(280px, 1fr);
  align-items: flex-start;
  gap: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(24, 25, 24, 1);

  @media only screen and (${breakpoints.mobile}) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    width: 100%;
    flex: 1 1 100%;
  }
`;

export const BottomContent = styled.div``;

export const TeamLeftInfo = styled.div`
  position: relative;

  @media only screen and (${breakpoints.mobile}) {
    display: flex;
    flex-direction: column-reverse;
  }

  h5 {
    opacity: 1;
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 18px;
  }

  h2 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 28px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 38px;
    overflow-wrap: anywhere;

    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  h3 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }

  .react-tooltip {
    background: #cfdae6;
    opacity: 1;
    color: rgba(4, 8, 2, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: center;
    line-height: 24px;

    h3 {
      font-family: "SatoshiBold";
      color: rgba(4, 8, 2, 1);
    }
  }
`;

export const FavoriteTeamWrap = styled.div`
  display: flex;
  flex-direciton: row;
  gap: 10px;

  img {
    width: 18px;
  }
`;

export const TeamRightInfo = styled.div`
  margin-left: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;

  @media only screen and (${breakpoints.mobile}) {
    padding: 0;
    margin-left: 0;
    min-width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  }

  ul {
    padding-left: 20px;
    margin: 0;

    li {
      list-style: disc;
      opacity: 1;
      color: ${(props) => props.theme.blueish2};
      font-family: "SatoshiMedium";
      font-size: 14px;
      font-weight: 500;
      font-style: Medium;
      letter-spacing: 0px;
      text-align: left;
      line-height: 24px;
    }
  }
`;

export const TeamHeaderFilters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  margin: 0;
  position: relative;
  z-index: 100;

  @media only screen and (${breakpoints.mobile}) {
    flex-wrap: wrap;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    gap: 10px;
  }
`;

export const TeamHeaderDropdownButton = styled(DropdownButton)`
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  line-height: 20px;
  padding-right: 20px;
  padding-bottom: 4px;

  img {
    width: 10px;
    height: 10px;
    right: 0;
    bottom: 8px;
  }
`;

export const TeamHeaderFilterField = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 0 14px 0 0;
  position: relative;
  z-index: inherit;

  & + & {
    padding-left: 14px;
  }

  /* Svaki field podiže z-index kad je "aktivan" - ali to rešavamo na Dropdown nivou */
  @media only screen and (${breakpoints.mobile}) {
    border: 1px solid ${(props) => props.theme.borderColor};
    border-left: 1px solid ${(props) => props.theme.borderColor} !important;
    border-radius: 6px;
    padding: 10px 14px;
    width: 100%;
  }
`;

export const TeamHeaderFilterLabel = styled.span`
  display: block;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 6px;
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (${breakpoints.mobile}) {
    flex-wrap: wrap;
    gap: 10px;
    align-items: baseline;

    > div {
      width: 30%;
    }
  }

  .teamTopCard {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TeamStatistics = styled.div`
  padding-top: 20px;

  h5 {
    opacity: 1;
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiRegular";
    font-size: 12px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 18px;
  }

  h4 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }
`;

export const SeeMoreButton = styled.div`
  // position: absolute;
  // right: 0px;
  // top: 0;
`;

export const AccessDenied = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100vh;
    background: rgba(15, 21, 33, 0.96);
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5000;
    pointer-events: all;
    backdrop-filter: blur(2px);
    font-family: "SatoshiBold";
    font-size: 28px;
    overscroll-behavior: contain;
    touch-action: none;
`;

export const TeamPageContainer = styled.div`
  position: relative;
  min-height: 100vh;
`;

export const AvatarWithCountryContainer = styled.div`
  position: relative;

  > img:first-child {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }

  .flag {
    position: absolute;
    object-fit: cover;
    top: -10px;
    right: -10px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
`;


const TEAM_MULTI_SEASON_STORAGE_KEY = "season_team_selection";

const toNumericId = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

const getParameterKey = (parameter) => {
  const normalizedId = toNumericId(
    parameter?.parameter_id ?? parameter?.param_id ?? parameter?.id
  );
  if (normalizedId !== null) {
    return `id:${normalizedId}`;
  }

  const fallbackName =
    parameter?.parameter_name || parameter?.name || parameter?.title || "";

  return fallbackName ? `name:${fallbackName}` : null;
};

const mergeMarkers = (...markerCollections) =>
  normalizeMarkerCollection(markerCollections.flat());

const mergeParameterList = (parameters = []) => {
  const mergedParameters = new Map();

  parameters.forEach((parameter) => {
    const parameterKey = getParameterKey(parameter);
    if (!parameterKey) {
      return;
    }

    const previousValue = mergedParameters.get(parameterKey) || {
      ...parameter,
      count: 0,
      value: 0,
      event_count: 0,
      unique_count: 0,
      unique_markers_count: 0,
      markers: [],
    };

    const nextValue = Number(parameter?.count ?? parameter?.value ?? 0);
    const safeValue = Number.isFinite(nextValue) ? nextValue : 0;

    const nextUniqueValue = Number(
      parameter?.event_count ?? parameter?.unique_markers_count ?? parameter?.unique_count ?? 0
    );
    const safeUniqueValue = Number.isFinite(nextUniqueValue) ? nextUniqueValue : 0;

    previousValue.count += safeValue;
    previousValue.value = previousValue.count;
    previousValue.event_count += safeUniqueValue;
    previousValue.unique_count = previousValue.event_count;
    previousValue.unique_markers_count = previousValue.event_count;
    previousValue.markers = mergeMarkers(previousValue.markers, parameter?.markers);

    mergedParameters.set(parameterKey, previousValue);
  });

  return Array.from(mergedParameters.values());
};

const mergeTeamPlayersInfoResponses = (responses = []) => {
  const mergedPlayersById = new Map();

  responses.forEach((response) => {
    (Array.isArray(response) ? response : []).forEach((player) => {
      const playerId = toNumericId(player?.id);
      if (playerId === null) {
        return;
      }

      const previousPlayer = mergedPlayersById.get(playerId) || {
        ...player,
        params: [],
        matches_played: 0,
      };

      previousPlayer.params = mergeParameterList([
        ...(previousPlayer.params || []),
        ...(Array.isArray(player?.params) ? player.params : []),
      ]);
      previousPlayer.matches_played += Number(player?.matches_played) || 0;

      mergedPlayersById.set(playerId, previousPlayer);
    });
  });

  return Array.from(mergedPlayersById.values());
};

const mergeTeamPageData = (responses = []) => {
  const primaryResponse = responses.find(Boolean) || null;
  if (!primaryResponse) {
    return null;
  }

  const mergedAvailableSeasons = getUniqueArrayObjectsByKey(
    responses.flatMap((response) =>
      Array.isArray(response?.available_seasons) ? response.available_seasons : []
    ),
    "id"
  );
  const mergedPlayersList = getUniqueArrayObjectsByKey(
    responses.flatMap((response) =>
      Array.isArray(response?.players_list) ? response.players_list : []
    ),
    "id"
  );
  // matches_list feeds the filter hook's matches (and through them the
  // match-backed overview stats), so it must cover every selected season —
  // not just the primary response's.
  const mergedMatchesList = getUniqueArrayObjectsByKey(
    responses.flatMap((response) =>
      Array.isArray(response?.matches_list) ? response.matches_list : []
    ),
    "id"
  );
  const mergedMatchesPlayed = getUniqueArrayObjectsByKey(
    responses.flatMap((response) =>
      Array.isArray(response?.matches_played)
        ? response.matches_played.map((item) => ({
            ...item,
            mergeKey: `${item?.season_id ?? ""}:${item?.competition__id ?? item?.competition_id ?? ""}`,
          }))
        : []
    ),
    "mergeKey"
  ).map(({ mergeKey, ...item }) => item);

  return {
    ...primaryResponse,
    available_seasons:
      mergedAvailableSeasons.length > 0
        ? mergedAvailableSeasons
        : primaryResponse?.available_seasons,
    players_list:
      mergedPlayersList.length > 0
        ? mergedPlayersList
        : primaryResponse?.players_list,
    matches_list:
      mergedMatchesList.length > 0
        ? mergedMatchesList
        : primaryResponse?.matches_list,
    matches_played:
      mergedMatchesPlayed.length > 0
        ? mergedMatchesPlayed
        : primaryResponse?.matches_played,
  };
};

const Index = () => {
  const { t } = useTranslation();
  const l = useLexicon();
  const { getTeamParameterLexiconId } = useParameterLexicon();

  const getTeamParameterDisplayName = (parameterInput) => {
    const fallbackName =
      typeof parameterInput === 'string'
        ? parameterInput
        : parameterInput?.parameter_name || parameterInput?.name || '';
    if (!fallbackName) return '';
    const lexiconId = getTeamParameterLexiconId(parameterInput);
    if (lexiconId) return l(lexiconId) || fallbackName;
    return fallbackName;
  };
  const isMobile = useMediaQuery({ query: `(${breakpoints.mobile})` });
  const [openSeeMore, setOpenSeeMore] = useState(false);

  const { id } = useParams();

  const TEAM_TAB_KEYS = ['overview', 'players', 'matches', 'events', 'shots', 'crosses'];
  const { selectedIndex: tabIndex, onSelect: onTabSelect } = useTabFromUrl(TEAM_TAB_KEYS);
  const [visitedTabs, setVisitedTabs] = useState(() => new Set([tabIndex]));

  useEffect(() => {
    setVisitedTabs((previousTabs) => {
      if (previousTabs.has(tabIndex)) {
        return previousTabs;
      }

      const nextTabs = new Set(previousTabs);
      nextTabs.add(tabIndex);
      return nextTabs;
    });
  }, [tabIndex]);

  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  // True once the Stats / Team Leaders payload has settled for the current
  // team+season. Drives the single page-level loader so sections never pop in
  // one-by-one.
  const [statsSettled, setStatsSettled] = useState(false);
  // True once the v1 team_opt shell (now the primary source for team_info and
  // the matches list) has settled — success or failure. Gates the page loader
  // so the matches section never flashes an empty "no matches" state before the
  // shell arrives.
  const [teamShellSettled, setTeamShellSettled] = useState(false);

  const [teamLeadersList, setTeamLeadersList] = useState();
  const [playersInfo, setPlayersInfo] = useState([]);

  const [paramsShotList, setParamsShotList] = useState([]);
  const [paramsCrossesList, setParamsCrossesList] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [accessDenied, setAccessDenied] = useState(false);
  const [openHeaderSeasonDropdown, setOpenHeaderSeasonDropdown] = useState(false);
  const [openHeaderCompetitionDropdown, setOpenHeaderCompetitionDropdown] = useState(false);
  const [openHeaderMatchesDropdown, setOpenHeaderMatchesDropdown] = useState(false);
  const [matchBackedOwnStats, setMatchBackedOwnStats] = useState([]);
  const [matchBackedOpponentStats, setMatchBackedOpponentStats] = useState([]);
  const [matchBackedOverviewLoading, setMatchBackedOverviewLoading] = useState(false);
  const matchBackedOverviewRequestKeyRef = useRef("");
  const matchBackedOverviewCacheRef = useRef(new Map());
  const inFlightMatchBackedOverviewRequestsRef = useRef(new Set());
  const fallbackTeamRequestKeyRef = useRef("");

  const [selectedSeasonIds, setSelectedSeasonIds] = useState(
    () =>
      readStoredSeasonSelection({
        multiKey: TEAM_MULTI_SEASON_STORAGE_KEY,
        legacyKey: "season_team",
      })
  );

  const navigate = useNavigate();
  const getSeasonLink = (seasonId) =>
    seasonId ? `/tournaments/competition/${seasonId}` : "/tournaments";

  const isHistoryPathForSeason = (path, seasonId) => {
    if (!path || !seasonId) return false;
    if (path === `/tournaments/competition/${seasonId}`) return true;
    const [pathname, queryString = ""] = path.split("?");
    if (pathname !== "/tournaments") return false;
    const params = new URLSearchParams(queryString);
    return params.get("seasonId") === String(seasonId);
  };

  const replaceSelectedSeasons = React.useCallback((nextSeasonSelection) => {
    const normalizedSeasonIds = normalizeSeasonSelectionIds(nextSeasonSelection);

    if (normalizedSeasonIds.length === 0) {
      return;
    }

    persistSeasonSelection({
      multiKey: TEAM_MULTI_SEASON_STORAGE_KEY,
      legacyKey: "season_team",
      seasonIds: normalizedSeasonIds,
    });

    setSelectedSeasonIds((previousSeasonIds) =>
      JSON.stringify(previousSeasonIds) === JSON.stringify(normalizedSeasonIds)
        ? previousSeasonIds
        : normalizedSeasonIds
    );
  }, []);

  const teamLeadersData = useTeamLeadersData({ teamId: id, selectedSeasonIds });
  const normalizedSelectedSeasonIds = useMemo(
    () => normalizeSeasonSelectionIds(selectedSeasonIds),
    [selectedSeasonIds]
  );
  const normalizedResolvedSeasonIds = useMemo(
    () => normalizeSeasonSelectionIds(teamLeadersData.resolvedSeasonIds),
    [teamLeadersData.resolvedSeasonIds]
  );
  const isOverviewDataSyncedToSelection = useMemo(() => {
    if (normalizedSelectedSeasonIds.length === 0) {
      return normalizedResolvedSeasonIds.length > 0;
    }

    if (normalizedSelectedSeasonIds.length !== normalizedResolvedSeasonIds.length) {
      return false;
    }

    const resolvedSeasonIdSet = new Set(
      normalizedResolvedSeasonIds.map((seasonId) => Number(seasonId))
    );

    return normalizedSelectedSeasonIds.every((seasonId) =>
      resolvedSeasonIdSet.has(Number(seasonId))
    );
  }, [normalizedResolvedSeasonIds, normalizedSelectedSeasonIds]);
  const effectiveSelectedSeasonIds =
    normalizedSelectedSeasonIds.length > 0
      ? normalizedSelectedSeasonIds
      : normalizedResolvedSeasonIds;
  const selectedSeasonQueryValue = useMemo(
    () => buildSeasonSelectionQueryValue(effectiveSelectedSeasonIds),
    [effectiveSelectedSeasonIds]
  );
  const currentTeamDataId = toNumericId(team?.team?.id ?? team?.id);
  const hasCurrentTeamShellData =
    currentTeamDataId !== null && currentTeamDataId === toNumericId(id);
  const initialMatchesForFilters = hasCurrentTeamShellData
    ? team?.matches_list ?? null
    : null;
  // The matches list (and the competitions derived from it) comes from the
  // season-scoped team_opt shell. teamShellSettled is reset on every team/season
  // change and set once the shell for that selection resolves, so this stays
  // true throughout each (re)fetch — holding the loader and gating the filter
  // hook's matches consumption so it never latches onto the previous season's
  // matches or flashes an empty "no matches" state.
  const isTeamShellPending = !teamShellSettled;

  useEffect(() => {
    if (teamLeadersData.loading || normalizedResolvedSeasonIds.length === 0) {
      return;
    }

    // Only override when selection is empty or no selected season appears in the
    // resolved set. Avoids a race where the team-leaders hook's setLoading(true)
    // is still queued while this effect sees stale resolvedSeasonIds from the
    // prior fetch, which would reset a freshly-added season back to the previous
    // value.
    const hasValidSelectedSeason = normalizedSelectedSeasonIds.some((id) =>
      normalizedResolvedSeasonIds.includes(Number(id))
    );

    if (normalizedSelectedSeasonIds.length === 0) {
      persistSeasonSelection({
        multiKey: TEAM_MULTI_SEASON_STORAGE_KEY,
        legacyKey: "season_team",
        seasonIds: normalizedResolvedSeasonIds,
      });
      return;
    }

    if (!hasValidSelectedSeason) {
      replaceSelectedSeasons(normalizedResolvedSeasonIds);
    }
  }, [
    normalizedResolvedSeasonIds,
    normalizedSelectedSeasonIds,
    teamLeadersData.loading,
    replaceSelectedSeasons,
  ]);

  const pageFilter = useTeamPageFilterController({
    teamId: id,
    availableSeasons: team?.available_seasons || [],
    selectedSeasonIds: effectiveSelectedSeasonIds,
    syncSelectedSeasons: replaceSelectedSeasons,
    l,
    initialMatches: initialMatchesForFilters,
    // Parameters are no longer bundled with the page payload; the filter hook
    // sources them itself (its own cache / v1 parameters endpoint).
    initialParameters: null,
    shouldEnrichMatches: tabIndex === 2,
    // Hold matches consumption until the team_opt shell for the current season
    // has settled, so the filter hook never latches onto the previous season's
    // matches (which would leave competitions empty until a manual refresh).
    isLoadingInitialData: isTeamShellPending,
  });

  useEffect(() => {
    // The v1 team_opt shell is the primary source for the team_info section
    // (team header, players_list, matches_list, available_seasons, matches_played)
    // now that the bundled v6 /overview call is gone. It is season-scoped, so it
    // must refetch on every season change — the matches list and the derived
    // competitions come from here. Dedup per team+season via the requestKey ref
    // so a plain re-render never refires the request.
    if (!id) {
      return undefined;
    }

    const requestKey = `${id}:${selectedSeasonQueryValue || ""}`;
    if (fallbackTeamRequestKeyRef.current === requestKey) {
      return undefined;
    }

    let isCancelled = false;
    fallbackTeamRequestKeyRef.current = requestKey;

    const fetchFallbackTeamShell = async () => {
      try {
        // The team_opt endpoint is season-scoped and only handles a single
        // season per request, so — like players_opt and team_leaders — we fetch
        // one request per selected season and merge the responses. Sending a
        // comma-joined year_season_id would return nothing for a multi-season
        // selection, leaving the matches list (and the Stats section it feeds)
        // empty. mergeTeamPageData dedupes players_list/available_seasons and
        // merges matches_played across responses.
        const seasonSelections =
          effectiveSelectedSeasonIds.length > 0
            ? effectiveSelectedSeasonIds
            : [null];

        const settledResponses = await Promise.allSettled(
          seasonSelections.map((seasonId) =>
            $apiV1.get(
              `/statistics/team_opt/${id}${
                seasonId ? `?year_season_id=${seasonId}` : ""
              }`
            )
          )
        );

        if (isCancelled) {
          return;
        }

        const responseData = settledResponses
          .filter((settled) => settled.status === "fulfilled")
          .map((settled) => settled.value?.data)
          .filter(Boolean);

        if (responseData.length === 0) {
          return;
        }

        const nextTeam = mergeTeamPageData(responseData);
        const nextTeamId = toNumericId(nextTeam?.team?.id ?? nextTeam?.id);
        if (nextTeamId !== null && nextTeamId === toNumericId(id)) {
          setTeam(nextTeam);
          trackEntityView({
            entity: nextTeam?.team,
            entityId: id,
            entityType: "team",
            sourceSurface: "team_profile",
            metadata: {
              season_id: selectedSeasonQueryValue || null,
              team_type: nextTeam?.team?.team_type,
              team_type_display: nextTeam?.team?.team_type_display,
            },
          });
        }
      } catch (error) {
        if (!isCancelled) {
          console.debug("Failed to load fallback team shell:", error);
        }
      } finally {
        if (!isCancelled) {
          setTeamShellSettled(true);
        }
      }
    };

    fetchFallbackTeamShell();

    return () => {
      isCancelled = true;
    };
  }, [
    id,
    selectedSeasonQueryValue,
  ]);

  const primarySelectedSeasonId = useMemo(
    () =>
      pageFilter.selectedSeasonItems?.[0]?.id ??
      effectiveSelectedSeasonIds[0] ??
      "",
    [effectiveSelectedSeasonIds, pageFilter.selectedSeasonItems]
  );

  const headerSeasonDropdownRef = useOutsideClick(() => {
    if (openHeaderSeasonDropdown) {
      setOpenHeaderSeasonDropdown(false);
    }
  });

  const headerCompetitionDropdownRef = useOutsideClick(() => {
    if (openHeaderCompetitionDropdown) {
      setOpenHeaderCompetitionDropdown(false);
    }
  });

  const headerMatchesDropdownRef = useOutsideClick(() => {
    if (openHeaderMatchesDropdown) {
      setOpenHeaderMatchesDropdown(false);
    }
  });

  const competitionSeasonIdMap = useMemo(() => {
    const map = new Map();
    const addToMap = (items, idKey, seasonKey) => {
      (items || []).forEach((item) => {
        const competitionId = Number(item?.[idKey] ?? item?.competition_id ?? item?.competition__id);
        const seasonId = item?.[seasonKey];
        if (competitionId && seasonId && !map.has(competitionId)) {
          map.set(competitionId, seasonId);
        }
      });
    };
    addToMap(team?.matches_played, "competition__id", "season_id");
    addToMap(pageFilter.competitions, "competition_id", "season_id");
    addToMap(pageFilter.matches, "competition_id", "season_id");
    return map;
  }, [team?.matches_played, pageFilter.competitions, pageFilter.matches]);

  const templateFilters = useMemo(
    () => ({
      competitionIds: (pageFilter.selectedCompetition ?? []).map((c) =>
        Number(c.competition_id)
      ),
      matchCountId: pageFilter.selectedMatchCount?.id ?? null,
      parameterIds: (pageFilter.selectedParameters?.checkedIds ?? []).map((idValue) =>
        Number(idValue)
      ),
    }),
    [
      pageFilter.selectedCompetition,
      pageFilter.selectedMatchCount,
      pageFilter.selectedParameters?.checkedIds,
    ]
  );

  const handleApplyTemplate = useCallback(
    (filters) => {
      pageFilter.actions.applyTemplate({
        competitionIds: filters?.competitionIds,
        matchCountId: filters?.matchCountId,
        parameterIds: filters?.parameterIds,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pageFilter.actions.applyTemplate]
  );

  const matchTableData = useMemo(() => {
    return (pageFilter.selectedMatches || []).map((match) => ({
      ...match,
      // Computed from the full (unfiltered) parameter set so column filtering
      // never flips a played match to "no data". Drives the score placeholder.
      hasStats: hasMatchStats(match),
      parameters: (match?.parameters || []).filter((parameter) => {
        if (pageFilter.selectedParameters.checkedIds.length === 0) {
          return true;
        }

        return pageFilter.selectedParameters.checkedIds.includes(
          parameter?.parameter_id || parameter?.id
        );
      }),
    }));
  }, [pageFilter.selectedMatches, pageFilter.selectedParameters.checkedIds]);

  const matchBackedOverviewParamIds = useMemo(() => {
    const visibleParamIds = collectOverviewStatParameterIds(teamLeadersList);

    return visibleParamIds.length > 0
      ? visibleParamIds
      : pageFilter.allParameterIds;
  }, [pageFilter.allParameterIds, teamLeadersList]);

  const selectedMatchIdsKey = useMemo(
    () => pageFilter.selectedMatchIds.join(","),
    [pageFilter.selectedMatchIds]
  );

  const matchBackedOverviewParamIdsKey = useMemo(
    () => matchBackedOverviewParamIds.join(","),
    [matchBackedOverviewParamIds]
  );

  useEffect(() => {
    if (
      pageFilter.selectedMatchIds.length === 0 ||
      matchBackedOverviewParamIds.length === 0
    ) {
      matchBackedOverviewRequestKeyRef.current = "";
      setMatchBackedOwnStats([]);
      setMatchBackedOpponentStats([]);
      setMatchBackedOverviewLoading(false);
      return;
    }

    let isCancelled = false;
    const requestKey = [
      id,
      selectedSeasonQueryValue || "",
      selectedMatchIdsKey,
      matchBackedOverviewParamIdsKey,
    ].join(":");

    const cachedStats = matchBackedOverviewCacheRef.current.get(requestKey);
    if (cachedStats) {
      matchBackedOverviewRequestKeyRef.current = requestKey;
      setMatchBackedOwnStats(cachedStats.own);
      setMatchBackedOpponentStats(cachedStats.opponent);
      setMatchBackedOverviewLoading(false);
      return;
    }

    if (inFlightMatchBackedOverviewRequestsRef.current.has(requestKey)) {
      matchBackedOverviewRequestKeyRef.current = requestKey;
      setMatchBackedOverviewLoading(true);
      return;
    }

    inFlightMatchBackedOverviewRequestsRef.current.add(requestKey);
    matchBackedOverviewRequestKeyRef.current = requestKey;
    setMatchBackedOverviewLoading(true);
    setMatchBackedOwnStats([]);
    setMatchBackedOpponentStats([]);

    const fetchMatchBackedOverview = async () => {
      try {
        const requestedParamIds = matchBackedOverviewParamIds.join(",");
        // Only send year_season_id for a single-season selection — the v1
        // endpoint doesn't understand a comma-joined list, and the `matches`
        // param already scopes the request to the selected seasons' matches.
        const isSingleSeasonSelection =
          Boolean(selectedSeasonQueryValue) &&
          !selectedSeasonQueryValue.includes(",");
        const baseParams = {
          matches: pageFilter.selectedMatchIds.join(","),
          params: requestedParamIds,
          // Overview consumes the aggregate `parameters` payload only. Avoid
          // computing and returning the unused per-match stats matrix.
          aggregate_only: true,
          ...(isSingleSeasonSelection
            ? { year_season_id: selectedSeasonQueryValue }
            : {}),
        };

        const [ownResponse, opponentResponse] = await Promise.all([
          $apiV1.get(`/stats/team/${id}`, { params: baseParams }),
          $apiV1.get(`/stats/team/${id}`, {
            params: {
              ...baseParams,
              oponnent: true,
            },
          }),
        ]);

        if (
          isCancelled ||
          matchBackedOverviewRequestKeyRef.current !== requestKey
        ) {
          return;
        }

        const ownStats = Array.isArray(ownResponse?.data?.parameters)
          ? [{ parameters: ownResponse.data.parameters }]
          : ownResponse?.data?.stats || [];
        const opponentStats = Array.isArray(opponentResponse?.data?.parameters)
          ? [{ parameters: opponentResponse.data.parameters }]
          : opponentResponse?.data?.stats || [];

        const aggregatedOwnStats = aggregateStatsResponse(ownStats);
        const aggregatedOpponentStats = aggregateStatsResponse(opponentStats);

        matchBackedOverviewCacheRef.current.set(requestKey, {
          own: aggregatedOwnStats,
          opponent: aggregatedOpponentStats,
        });

        setMatchBackedOwnStats(aggregatedOwnStats);
        setMatchBackedOpponentStats(aggregatedOpponentStats);
      } catch (error) {
        if (
          !isCancelled &&
          matchBackedOverviewRequestKeyRef.current === requestKey
        ) {
          console.error("Error fetching match-backed overview stats:", error);
          setMatchBackedOwnStats([]);
          setMatchBackedOpponentStats([]);
        }
      } finally {
        inFlightMatchBackedOverviewRequestsRef.current.delete(requestKey);
        if (
          !isCancelled &&
          matchBackedOverviewRequestKeyRef.current === requestKey
        ) {
          setMatchBackedOverviewLoading(false);
        }
      }
    };

    fetchMatchBackedOverview();

    return () => {
      isCancelled = true;
    };
  }, [id, matchBackedOverviewParamIds, matchBackedOverviewParamIdsKey, pageFilter.selectedMatchIds, selectedMatchIdsKey, selectedSeasonQueryValue]);

  const overviewLeaders = useMemo(
    () =>
      buildMatchBackedOverview({
        seasonLeaders: teamLeadersList,
        ownStats: matchBackedOwnStats,
        opponentStats: matchBackedOpponentStats,
      }),
    [matchBackedOpponentStats, matchBackedOwnStats, teamLeadersList]
  );

  const topCardStats = useMemo(() => {
    const statsToDisplay = [
      "Goals +",
      "Yellow Cards",
      "Red Cards",
      "Passes",
      "Passes +",
      "Passes -",
      "Passes +, %",
    ];

    return statsToDisplay
      .map((statName) =>
        overviewLeaders?.main_stats?.find(
          (item) =>
            item?.name === statName || item?.parameter_name === statName
        )
      )
      .filter(Boolean);
  }, [overviewLeaders]);

  // Re-gate the page whenever the team or season selection changes so the
  // unified loader waits for the *new* stats to settle instead of flashing the
  // previous season's data.
  useEffect(() => {
    setStatsSettled(false);
    setTeamShellSettled(false);
  }, [id, selectedSeasonQueryValue]);

  useEffect(() => {
    if (!teamLeadersData.loading && !teamLeadersData.data && teamLeadersData.error) {
      setStatsSettled(true);
    }
  }, [teamLeadersData.data, teamLeadersData.error, teamLeadersData.loading]);

  // Single page-level gate: hold the entire team view behind one loader until
  // every section's data has settled — the team shell, the filter params, and
  // the Team Leaders payload. Previously the shell rendered early and the slow
  // stats sections popped in 3-5s later (the stagger).
  useEffect(() => {
    const isPageLoading =
      teamLeadersData.loading ||
      pageFilter.loadingMatches ||
      !statsSettled ||
      isTeamShellPending;
    setLoading(isPageLoading);
    setLoadingList(isPageLoading);
  }, [teamLeadersData.loading, pageFilter.loadingMatches, statsSettled, isTeamShellPending]);

  // Populate the Team Leaders section from the dedicated v6 endpoint. The Stats
  // sections (main_stats / in_attack / in_defence) are derived from the
  // match-backed per-match stats inside buildMatchBackedOverview, so the payload
  // only needs to carry team_leaders. team_info/trackEntityView are owned by the
  // team_opt shell effect; parameter caching by useTeamPageFilterController.
  useEffect(() => {
    if (teamLeadersData.data) {
      setTeamLeadersList(teamLeadersData.data);
    }
    if (!teamLeadersData.loading) {
      setStatsSettled(true);
    }
  }, [teamLeadersData.data, teamLeadersData.loading]);

  useEffect(() => {
    let breadcrumbsAreSet = false;

    setBreadcrumbs([
      {
        title: l(1),
        link: "/tournaments",
      },
      {
        title: `${team?.team?.name}`,
      },
    ]);

    const history = JSON.parse(localStorage.getItem('pageHistory')) || [];
    const reversedHistory = [...history].reverse();
    const competitionsWithMatches = getUniqueCompetitionsWithMatches(team?.matches_played);

    competitionsWithMatches?.forEach((item) => {
      reversedHistory.forEach((historyItem) => {
        if (isHistoryPathForSeason(historyItem?.path, item.season_id)) {
          setBreadcrumbs([
            {
              title: item.title || item.competition__name || item.competition_name || item.competition,
              link: getSeasonLink(item.season_id),
            },
            {
              title: `${team?.team?.name}`,
            },
          ]);
          breadcrumbsAreSet = true;
          return;
        }
      });

    });

    if (!breadcrumbsAreSet) {
      const competition = competitionsWithMatches.reverse()[0];

      if (competition)
      setBreadcrumbs([
        {
          title: competition.title || competition.competition__name || competition.competition_name || competition.competition,
          link: getSeasonLink(competition.season_id),
        },
        {
          title: `${team?.team?.name}`,
        },
      ]);

    }
  }, [l, team]);

  const handleSelectChange = (event) => {
    const selectedSeasonId = event.target.value;
    replaceSelectedSeasons([selectedSeasonId]);
  };

  useEffect(() => {
    if (selectedSeasonIds.length === 0) {
      return;
    }

    const availableSeasons = Array.isArray(team?.available_seasons)
      ? team.available_seasons
      : [];

    if (availableSeasons.length === 0) {
      return;
    }

    const availableSeasonIdsSet = new Set(
      availableSeasons.map((item) => Number(item?.id))
    );
    const nextSelectedSeasonIds = normalizeSeasonSelectionIds(selectedSeasonIds).filter(
      (seasonId) => availableSeasonIdsSet.has(Number(seasonId))
    );

    // None of the persisted seasons exist for this team — e.g. a season carried
    // over from another team via localStorage. Fall back to the newest available
    // season (availableSeasons[0] is ordered newest-first) so the header/filters
    // never sit with nothing selected.
    if (nextSelectedSeasonIds.length === 0) {
      const newestSeasonId = toNumericId(availableSeasons[0]?.id);
      if (newestSeasonId !== null) {
        replaceSelectedSeasons([newestSeasonId]);
      }
      return;
    }

    if (
      JSON.stringify(nextSelectedSeasonIds) !== JSON.stringify(selectedSeasonIds)
    ) {
      replaceSelectedSeasons(nextSelectedSeasonIds);
    }
  }, [replaceSelectedSeasons, selectedSeasonIds, team?.available_seasons]);

    useEffect(() => {
        $apiV2.get('/access/check/' + id + '/team')
          .then((response) => {
            // if request is successful, ensure overlay is hidden
            setAccessDenied(false);
          })
          .catch((error) => {
            if (error?.response?.status === 403) {
              setAccessDenied(true);
              setTimeout(() => {
                navigate('/dashboard')
              }, 3000);
            } else {
              setAccessDenied(false);
            }
          });
    }, [id, navigate]);

  const getMatches = async (id, season, params = [], downloadType) => {
    try {
      let currentParams = params;
      if (sessionStorage.getItem("teamParameters") && params?.length === 0) {
        const params = excludeAttackingTypesParameterGroups(
          JSON.parse(sessionStorage.getItem("teamParameters"))
        );
        const checkedIds = params.flatMap((group) =>
          group[1].filter((item) => item.checked).map((item) => item.id)
        );
        currentParams = checkedIds;
      }
      if (downloadType) {
        const downloadNotifId = 'downloading-team-matches';
        addNotification('Downloading...', 'info', { id: downloadNotifId, duration: 0 });
        try {
          const seasonQueryValue = buildSeasonSelectionQueryValue(
            season ?? effectiveSelectedSeasonIds
          );
          const file = await $apiV2.get(
            `/platform/team/${id}/matches_opt?${seasonQueryValue ? `year_season_id=${seasonQueryValue}&` : ""}params_ids=${currentParams.join(",")}&format_data=${downloadType}`
          );
          if (downloadType === 'xml') {
            const response = await fetch(file.data.file_url);
            if (!response.ok) throw new Error('Network response was not ok');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = file.data.file_url.split("/")[
              file.data.file_url.split("/").length - 1
            ];
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          } else {
            const a = document.createElement("a");
            a.href = file.data.file_url;
            a.download =
              file.data.file_url.split("/")[
              file.data.file_url.split("/").length - 1
              ];
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } finally {
          removeNotification(downloadNotifId);
        }
        return
      }
    } catch (error) {
      console.error("Error fetching players:", error);
      if (downloadType) {
        addNotification(`Error in receiving ${downloadType} file.`, "error");
      }
      return Promise.reject(error);
    }
  };

  const getPlayersInfo = React.useCallback(async (id) => {
    try {
      const requestSeasonSelections =
        effectiveSelectedSeasonIds.length > 0
          ? effectiveSelectedSeasonIds
          : [null];
      const responses = await Promise.all(
        requestSeasonSelections.map((seasonId) =>
          seasonId
            ? $apiV2.get(`/platform/team/${id}/players_opt?year_season_id=${seasonId}`)
            : $apiV2.get(`/platform/team/${id}/players_opt`)
        )
      );
      setPlayersInfo(
        mergeTeamPlayersInfoResponses(responses.map((response) => response?.data))
      );
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
    }
  }, [effectiveSelectedSeasonIds]);

  const getShotParams = async () => {
    try {
      const response = await $apiV1.get(`/stats/parameters/team?group=2`);
      setParamsShotList(response?.data.results);
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
    }
  };

  const getCrossesParams = async () => {
    try {
      const response = await $apiV1.get(`/stats/parameters/team?group=3`);
      setParamsCrossesList(response?.data.results);
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
    }
  };

  // Deferred: load players info only when Players tab is active
  useEffect(() => {
    if (tabIndex !== 1) return;
    getPlayersInfo(id);
  }, [tabIndex, id, getPlayersInfo]);

  // Deferred: load shot params only when Shots tab is first activated
  useEffect(() => {
    if (tabIndex !== 4 || paramsShotList.length > 0) return;
    getShotParams();
  }, [tabIndex, paramsShotList.length]); // eslint-disable-line react-hooks/exhaustive-deps

  // Deferred: load crosses params only when Crosses tab is first activated
  useEffect(() => {
    if (tabIndex !== 5 || paramsCrossesList.length > 0) return;
    getCrossesParams();
  }, [tabIndex, paramsCrossesList.length]); // eslint-disable-line react-hooks/exhaustive-deps

  const [userDetail, setUserDetail] = useState("");

  const getUser = async () => {
    try {
      const response = await getUserProfile();
      setUserDetail(response?.data?.user);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Current user info is needed only by events/shots/crosses tabs, so keep it
  // off the initial Overview/Matches path.
  useEffect(() => {
    if (![3, 4, 5].includes(tabIndex) || userDetail) {
      return;
    }

    getUser();
  }, [tabIndex, userDetail]); // eslint-disable-line react-hooks/exhaustive-deps

  const { notifications, removeNotification, addNotification } =
    useNotification();

  const isCanClickTeamStat = (item) => {
    const statName = item?.name || item?.parameter_name || "";
    return (
      item?.count === 0 ||
      statName.includes("%") ||
      statName.includes("Mins Played") ||
      statName.includes("Passes")
    );
  };

  const teamLogo = team?.logo ?? team?.team?.logo;
  const selectedHeaderSeasonLabel = getSeasonSummaryLabel(
    pageFilter.selectedSeasonItems,
    l(992)
  );
  const selectedHeaderCompetitionLabel = getCompetitionSummaryLabel(
    pageFilter.selectedCompetition,
    l(993)
  );

  return (
    <MainWrapper>
      <Navigation />
      <MainWrapperFavorite
        className={
          localStorage.getItem("navigationOpen") === "true"
            ? ""
            : "fullWidthPage"
        }
        style={accessDenied ? { overflow: 'hidden' } : undefined}
      >
        <TeamPageContainer>
          {accessDenied && (
            <AccessDenied>
              {l(1119)}
            </AccessDenied>
          )}
        <TopWrapper>
          <IntroText
            smallTitle={t("favorites.smallTitle")}
            title={l(987)}
          />
          <Search />
        </TopWrapper>

        {loading ? (
          <LoadingWrapper>
            <Oval
              visible={true}
              height="80"
              width="80"
              secondaryColor={
                localStorage.getItem("theme") === "light"
                  ? "#4E5255"
                  : "#CFDAE6"
              }
              color={
                localStorage.getItem("theme") === "light"
                  ? "#2363F7"
                  : "#4fa94d"
              }
              ariaLabel="oval-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </LoadingWrapper>
        ) : (
          <>
            <Breadcrumbs items={breadcrumbs} />
            <TeamCardWrap>
              <TeamContent>
                <TopContent>
                  <Info>
                    <AvatarWithCountryContainer>
                      <img
                        src={teamLogo || teamLogoPlaceholder}
                        alt={team?.team?.name ?? ""}
                        className="team-logo"
                        onError={swapInTeamLogoPlaceholder}
                      />{" "}
                      {team?.team?.country?.flag && (
                        <img
                          className="flag"
                          src={getMediaUrl(team.team.country.flag)}
                          alt={team.team.country?.name}
                        />
                      )}
                    </AvatarWithCountryContainer>
                    <TeamLeftInfo>
                      {team?.team?.country?.short_name && (
                        <h5>{team.team.country.short_name}</h5>
                      )}
                      {isMobile && (
                        <SeeMoreButton
                          style={{ marginTop: "10px" }}
                          onClick={() => setOpenSeeMore(!openSeeMore)}
                        >
                          <ButtonLink
                            title={`${openSeeMore ? "see less" : "see more"}`}
                            color={"gray"}
                            underline
                          />
                        </SeeMoreButton>
                      )}

                      <FavoriteTeamWrap>
                        <h2>
                          {team?.team?.name}
                          {/* <img
                            src={isFavorite ? starOn : starOff}
                            alt="Favorite star"
                            style={{
                              width: "18px",
                              height: "100%",
                              cursor: "pointer",
                            }}
                            onClick={toggleFavorite}
                          /> */}
                        </h2>
                      </FavoriteTeamWrap>
                      <h3>{team?.team?.team_status_display}</h3>
                    </TeamLeftInfo>
                  </Info>

                  <TeamHeaderFilters>
                    <TeamHeaderFilterField style={{ flex: "0 0 22%", minWidth: 120 }}>
                      <TeamHeaderFilterLabel>{l(453)}</TeamHeaderFilterLabel>
                      <Dropdown
                        ref={headerSeasonDropdownRef}
                        disabled={!pageFilter.availableSeasons?.length}
                      >
                        <TeamHeaderDropdownButton
                          onClick={() =>
                            setOpenHeaderSeasonDropdown((prev) => !prev)
                          }
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              display: "inline-block",
                            }}
                          >
                            {selectedHeaderSeasonLabel}
                          </span>
                          <img
                            src={openHeaderSeasonDropdown ? closeDropdown : arrowDown}
                            alt="toggle"
                          />
                        </TeamHeaderDropdownButton>
                        <DropdownContent $show={openHeaderSeasonDropdown}>
                          {pageFilter.availableSeasons?.length > 0 ? (
                            pageFilter.availableSeasons.map((seasonItem) => (
                              <MatchDropdownItem
                                key={seasonItem.id}
                                selected={effectiveSelectedSeasonIds.includes(
                                  Number(seasonItem.id)
                                )}
                                onClick={() =>
                                  pageFilter.actions.selectSeason(seasonItem)
                                }
                              >
                                <MatchCheckbox
                                  type="checkbox"
                                  readOnly
                                  checked={effectiveSelectedSeasonIds.includes(
                                    Number(seasonItem.id)
                                  )}
                                />
                                {seasonItem.years || seasonItem.id}
                              </MatchDropdownItem>
                            ))
                          ) : (
                            <DropdownItem>{l(464)}</DropdownItem>
                          )}
                        </DropdownContent>
                      </Dropdown>
                    </TeamHeaderFilterField>

                    <TeamHeaderFilterField style={{ flex: "1 1 56%", minWidth: 150 }}>
                      <TeamHeaderFilterLabel>{l(454)}</TeamHeaderFilterLabel>
                      <Dropdown
                        ref={headerCompetitionDropdownRef}
                        disabled={
                          pageFilter.loadingMatches ||
                          pageFilter.competitions?.length === 0 ||
                          pageFilter.selectedSeasonItems?.length === 0
                        }
                      >
                        <TeamHeaderDropdownButton
                          onClick={() =>
                            setOpenHeaderCompetitionDropdown((prev) => !prev)
                          }
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              display: "inline-block",
                            }}
                          >
                            {selectedHeaderCompetitionLabel}
                          </span>
                          <img
                            src={
                              openHeaderCompetitionDropdown
                                ? closeDropdown
                                : arrowDown
                            }
                            alt="toggle"
                          />
                        </TeamHeaderDropdownButton>
                        <DropdownContent $show={openHeaderCompetitionDropdown}>
                          {pageFilter.competitions?.length > 0 ? (
                            pageFilter.competitions.map((competitionItem) => (
                              <MatchDropdownItem
                                key={competitionItem.competition_id}
                                selected={pageFilter.selectedCompetition?.some(
                                  (selectedItem) =>
                                    String(selectedItem?.competition_id) ===
                                    String(competitionItem?.competition_id)
                                )}
                                onClick={() =>
                                  pageFilter.actions.toggleCompetition(
                                    competitionItem
                                  )
                                }
                              >
                                <MatchCheckbox
                                  type="checkbox"
                                  readOnly
                                  checked={pageFilter.selectedCompetition?.some(
                                    (selectedItem) =>
                                      String(selectedItem?.competition_id) ===
                                      String(competitionItem?.competition_id)
                                  )}
                                />
                                {competitionItem.competition}
                              </MatchDropdownItem>
                            ))
                          ) : (
                            <DropdownItem>{l(464)}</DropdownItem>
                          )}
                        </DropdownContent>
                      </Dropdown>
                    </TeamHeaderFilterField>

                    <TeamHeaderFilterField style={{ flex: "0 0 22%", minWidth: 120 }}>
                      <TeamHeaderFilterLabel>{l(7)}</TeamHeaderFilterLabel>
                      <Dropdown
                        ref={headerMatchesDropdownRef}
                        disabled={
                          pageFilter.loadingMatches ||
                          pageFilter.matches?.length === 0 ||
                          pageFilter.selectedCompetition?.length === 0
                        }
                      >
                        <TeamHeaderDropdownButton
                          onClick={() =>
                            setOpenHeaderMatchesDropdown((prev) => !prev)
                          }
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              display: "inline-block",
                            }}
                          >
                            {pageFilter.selectedMatchCount?.title || l(994)}
                          </span>
                          <img
                            src={openHeaderMatchesDropdown ? closeDropdown : arrowDown}
                            alt="toggle"
                          />
                        </TeamHeaderDropdownButton>
                        <DropdownContent $show={openHeaderMatchesDropdown}>
                          {pageFilter.matchesCountList?.map((option) => (
                            <DropdownItem
                              key={option.id}
                              selected={
                                pageFilter.selectedMatchCount?.id === option.id
                              }
                              onClick={() => {
                                pageFilter.actions.selectMatchCount(option);
                                setOpenHeaderMatchesDropdown(false);
                              }}
                            >
                              {option.title}
                            </DropdownItem>
                          ))}
                        </DropdownContent>
                      </Dropdown>
                    </TeamHeaderFilterField>

                  </TeamHeaderFilters>
                  <TeamRightInfo>
                    <ul>
                      {(pageFilter.selectedCompetition || []).map((comp, index) => {
                        const seasonId = competitionSeasonIdMap.get(Number(comp?.competition_id));
                        return (
                          <li
                            key={comp.competition_id || index}
                            onClick={() => navigate(getSeasonLink(seasonId))}
                            style={{ cursor: seasonId ? "pointer" : "default" }}
                          >
                            {comp.competition}
                          </li>
                        );
                      })}
                    </ul>
                  </TeamRightInfo>
                </TopContent>
                {openSeeMore && isMobile ? (
                  <BottomContent>
                    <TeamStatistics>
                      <Stat>
                        {topCardStats.map((item) => {
                          const displayName = getTeamParameterDisplayName(item);
                          return (
                            <div key={item.id || item.parameter_id}>
                              <h5>{displayName}</h5>
                              <h4>
                                {Number.isInteger(item.count)
                                  ? item.count.toLocaleString()
                                  : Number(item.count || 0).toFixed(1)}
                              </h4>
                            </div>
                          );
                        })}
                      </Stat>
                    </TeamStatistics>
                  </BottomContent>
                ) : (
                  !isMobile && (
                    <BottomContent>
                      <TeamStatistics>
                        <Stat>
                          {topCardStats.map((item) => {
                            const displayName = getTeamParameterDisplayName(item);
                            return (
                              <div
                                key={item.id || item.parameter_id}
                                className="statistics teamTopCard"
                              >
                                <h5>{displayName}</h5>
                                <h4
                                  style={
                                    isCanClickTeamStat(item)
                                      ? { cursor: "not-allowed" }
                                      : { cursor: "pointer" }
                                  }
                                  onClick={() => {
                                    !isCanClickTeamStat(item) &&
                                      openStatVideo(
                                        {
                                          kind: "team",
                                          id,
                                          matchIds: pageFilter.selectedMatchIds,
                                          paramId:
                                            item?.parameter_id ?? item?.id,
                                          opponent: false,
                                        },
                                        `${displayName} - ${team?.team?.name}`
                                      );
                                  }}
                                >
                                  {Number.isInteger(item.count)
                                    ? item.count.toLocaleString()
                                    : Number(item.count || 0).toFixed(1)}
                                </h4>
                              </div>
                            );
                          })}
                        </Stat>
                      </TeamStatistics>
                    </BottomContent>
                  )
                )}
              </TeamContent>
            </TeamCardWrap>

            {/* Tabs */}
            <TabsWrapper forceRenderTabPanel={true} selectedIndex={tabIndex} onSelect={onTabSelect}>
              <TopList>
                <TabListWrapper
                  className="teamTabs"
                  style={{ scrollbarWidth: "none" }}
                >
                  <TabTitle>{l(988)}</TabTitle>
                  <TabTitle>{l(5)}</TabTitle>
                  <TabTitle>{l(7)}</TabTitle>
                  <TabTitle>{l(9)}</TabTitle>
                  <TabTitle>{l(18)}</TabTitle>
                  <TabTitle>{l(587)}</TabTitle>
                </TabListWrapper>
              </TopList>

              <TabContent hidden={true}>
                <Overview
                  table={team}
                  leaders={overviewLeaders}
                  loadingList={loadingList}
                  statsLoading={matchBackedOverviewLoading}
                  id={id}
                  loadingStatMatch={false}
                  teamInfo={playersInfo}
                  handleSelectChange={handleSelectChange}
                  selectedSeason={primarySelectedSeasonId}
                  matchesTable={pageFilter.selectedMatches}
                />
              </TabContent>
              <TabContent hidden={true}>
                {visitedTabs.has(1) && (
                  <SmrtSearchTable
                    table={team?.players_list}
                    info={playersInfo}
                  />
                )}
              </TabContent>
              <TabContent hidden={true}>
                {visitedTabs.has(2) && (
                  <MatchTable
                    team={team?.team?.name}
                    loadingStat={false}
                    statMathc={matchTableData}
                    onSeasonChange={(season, params, downloadType) =>
                      getMatches(id, season, params, downloadType)
                    }
                    season={selectedSeasonQueryValue || primarySelectedSeasonId}
                    filterState={{
                      availableSeasons: pageFilter.availableSeasons,
                      loadingMatches: pageFilter.loadingMatches,
                      selectedSeasonItems: pageFilter.selectedSeasonItems,
                      competitions: pageFilter.competitions,
                      selectedCompetition: pageFilter.selectedCompetition,
                      matchesCountList: pageFilter.matchesCountList,
                      selectedMatchCount: pageFilter.selectedMatchCount,
                      matches: pageFilter.matches,
                      selectedMatches: pageFilter.selectedMatches,
                      selectedParameters: pageFilter.selectedParameters,
                      parameterGroups: pageFilter.parameterGroups,
                    }}
                    filterActions={pageFilter.actions}
                    templateFilters={templateFilters}
                    onApplyTemplate={handleApplyTemplate}
                  />
                )}
              </TabContent>
              <TabContent hidden={true}>
                {visitedTabs.has(3) && (
                  <EventsMatches
                    team={team}
                    paramsList={teamEventsParams}
                    user={userDetail}
                    selectedMatchIds={pageFilter.selectedMatchIds}
                    selectedMatches={pageFilter.selectedMatches}
                    isActive={tabIndex === 3}
                  />
                )}
              </TabContent>
              <TabContent hidden={true}>
                {visitedTabs.has(4) && (
                  <ShotsTeam
                    players={team}
                    paramsList={teamEventsParams}
                    paramsShotList={paramsShotList}
                    user={userDetail}
                    selectedMatchIds={pageFilter.selectedMatchIds}
                  />
                )}
              </TabContent>
              <TabContent hidden={true}>
                {visitedTabs.has(5) && (
                  <CrossesTeam
                    players={team}
                    paramsList={teamEventsParams}
                    paramsShotList={paramsCrossesList}
                    user={userDetail}
                    selectedMatchIds={pageFilter.selectedMatchIds}
                  />
                )}
              </TabContent>
            </TabsWrapper>
          </>
        )}
        </TeamPageContainer>
      </MainWrapperFavorite>

      {/* display notifications */}
      <NotificationList
        notifications={notifications}
        onClose={removeNotification}
      />
    </MainWrapper>
  );
};

export default Index;
